import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useManualBillingReportsEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.ManualBillingReports, false);

  return Boolean(isEnabled);
}
